<template>
    <header class="header position--fixed background--white color--grey">
        <div class="header--content display--grid container">
            <!-- Logo -->
            <router-link
                class="header__logo__anchor position--relative display--block accessibility--pseudo accessibility--active"
                to="/clients">
                <img
                    :src="require('@/assets/images/logo.png')"
                    alt="Aprh"
                    class="header__logo__image"
                    aria-label="Aprh"
                />
            </router-link>
            <!-- search -->
            <search :canSearch="canSearch"/>
            <!-- Profile -->
            <nav class="header__navigation display--flex">
                <router-link
                    class="header__navigation__anchor position--relative display--flex accessibility--pseudo accessibility--active"
                    :title="$t('global.myProfile')"
                    :to="`/users/${ userId }`">
                    <icon-user />
                </router-link>
                <router-link
                    class="header__navigation__anchor position--relative display--flex accessibility--pseudo accessibility--active"
                    :title="$t('global.settings')"
                    :to="`/fees`">
                    <icon-settings />
                </router-link>
            </nav>
        </div>
    </header>
</template>

<script>
import { reactive, toRefs } from '@vue/composition-api';

// store
// eslint-disable-next-line
import { useStore } from '@/hooks/use-store';

export default {
    components: {
        Search: () => import( /* webpackChunkName: 'Search' */ '@/components/bundles/layout/search/Search' ),
        IconSettings: () => import( /* webpackChunkName: 'IconSettings' */ '@/components/bundles/layout/images/icons/IconSettings' ),
        IconUser: () => import( /* webpackChunkName: 'IconUser' */ '@/components/bundles/layout/images/icons/IconUser' )
    },
    props: {
        canSearch: Boolean
    },
    setup () {
        const { getters } = useStore();

        const state = reactive({
            userId: getters.userId
        });

        return {
            ...toRefs( state )
        };
    }
};
</script>

<style lang="scss">
    .header {
        @include transform-position( 0, false, false, false );
        @include dimensions( 100%, auto );
        z-index: 20;
        padding: 25px 0 20px;
        &--content {
            grid-template-columns: 213px 1fr 213px;
            align-items: center;
            grid-gap: 20px;
        }
        &__logo {
            &__image {
                @include dimensions( 101px, auto );
            }
        }
        &__navigation {
            gap: 13px;
            @include position-grid( center, flex-end );
            &__anchor {
                @include transition( all .3s ease-in-out );
                @include position-grid( center, center );
                @include dimensions( 40px );
                @include rounded-corner( 5px );
                background: transparent;
                &:hover {
                    background: $color-blue;
                    path {
                        stroke: $color-white;
                    }
                }
            }
        }
    }
</style>